import * as Mod1 from "./discourse/initializers/oauth2-basic-admin-plugin-configuration-nav";
const compatModules = {
  "discourse/initializers/oauth2-basic-admin-plugin-configuration-nav": Mod1,
};
export { compatModules };
export default compatModules;
